export default __webpack_public_path__ + "static/media/176.b7066efa.jpg";